import React, { ReactNode } from 'react';
import { StyledSpaceSection } from './styled';

interface SpaceSectionProps {
  children: ReactNode;
  smallVerticalSpace?: boolean;
}

export const SpaceSection: React.FC<SpaceSectionProps> = ({
  children,
  smallVerticalSpace = false
}) => (
  <StyledSpaceSection $smallVerticalSpace={smallVerticalSpace}>
    {children}
  </StyledSpaceSection>
);
